import { render, staticRenderFns } from "./StatCalcCard.vue?vue&type=template&id=c668b5c8&scoped=true&"
import script from "./StatCalcCard.vue?vue&type=script&lang=ts&"
export * from "./StatCalcCard.vue?vue&type=script&lang=ts&"
import style0 from "./StatCalcCard.vue?vue&type=style&index=0&id=c668b5c8&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c668b5c8",
  null
  
)

export default component.exports